import { db } from '../../../firebase';
import {
  collection,
  addDoc,
  getDocs,
  deleteDoc,
  orderBy,
  query,
  serverTimestamp,
} from 'firebase/firestore';

const MAX_RECENT = 5;

const logRecentSearch = async (uid, entry) => {
  if (!uid || !entry?.label) return;

  const col = collection(db, 'users', uid, 'recentSearches');

  await addDoc(col, {
    type: entry.type || 'calcul',
    label: entry.label,
    detail: entry.detail ?? null,
    timestamp: serverTimestamp(),
  });

  const snap = await getDocs(query(col, orderBy('timestamp', 'desc')));

  const toDelete = snap.docs.slice(MAX_RECENT);
  await Promise.all(toDelete.map((d) => deleteDoc(d.ref)));
};

export default logRecentSearch;
